import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import type { GalleryItem } from '../types/content';
type AutoGalleryProps = {
  items: GalleryItem[];
  label: string;
  className?: string;
  /** Vitesse de défilement en pixels par seconde. */
  speed?: number;
};
const slideClass = 'shrink-0 h-[180px] w-[180px] sm:h-[220px] sm:w-[220px] overflow-hidden rounded-[20px] bg-sand';
export function AutoGallery({
  items,
  label,
  className = 'bg-peach',
  speed = 45
}: AutoGalleryProps) {
  const reduceMotion = useReducedMotion();
  const setRef = useRef<HTMLUListElement>(null);
  const [duration, setDuration] = useState(45);
  useEffect(() => {
    const el = setRef.current;
    if (!el) return;
    const update = () => {
      // Largeur d’un jeu complet (gap inclus via padding-right) ÷ vitesse.
      const width = el.getBoundingClientRect().width;
      if (width > 0) setDuration(width / speed);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [speed, reduceMotion]);
  const renderSlides = (hidden: boolean) => items.map(item => <li key={`${hidden ? 'clone-' : ''}${item.id}`} className={slideClass} data-id="element-19" data-mp="1zorco8bo1sk9">
        <img src={item.src} alt={hidden ? '' : item.alt} loading="lazy" decoding="async" draggable={false} className="h-full w-full object-cover" data-id="element-20" data-mp="2dninnlv8ey46" />
      </li>);
  if (reduceMotion) {
    return <section aria-label={label} className={`py-8 sm:py-10 ${className}`} data-id="element-21" data-mp="2nistylsnxrnr">
        <ul tabIndex={0} aria-label={label} className="max-w-6xl mx-auto flex gap-[22px] overflow-x-auto snap-x px-5 sm:px-8 no-scrollbar" data-id="element-22" data-mp="2ik978j68wbuc">
          {renderSlides(false)}
        </ul>
      </section>;
  }
  return <section aria-label={label} className={`overflow-hidden py-8 sm:py-10 ${className}`} data-id="element-23" data-mp="2scewhl544f5u">
      <div className="marquee-track flex" style={{
      '--marquee-duration': `${duration}s`
    } as React.CSSProperties} data-id="element-24" data-mp="36bwo089sm6iw">
        <ul ref={setRef} className="flex gap-[22px] pr-[22px]" aria-label={label} data-id="element-25" data-mp="31dlgw5avua4d">
          {renderSlides(false)}
        </ul>
        <ul className="flex gap-[22px] pr-[22px]" aria-hidden="true" data-id="element-26" data-mp="23xgomjbgrp8w">
          {renderSlides(true)}
        </ul>
      </div>
    </section>;
}